import { DateRange } from 'react-day-picker';
import {
	defaultSalesDetailDto,
	defaultSalesHeaderDto,
	SalesDetailDto,
	SalesHeaderDto,
} from 'src/dtos/sales/salesBillDto';

/**
 * SAL2060_R01 거래처별 집계 DTO (Header/Master)
 * 좌측 그리드에 표시
 */
export interface SAL2060_R01HeaderDto extends SalesHeaderDto {
    startDate?: string;
    endDate?: string;
    listLength?: number;
    refetchListLength?: number;
}

/**
 * SAL2060_R01 상세 내역 DTO (Detail)
 * 우측 그리드에 표시
 */
export interface SAL2060_R01DetailDto extends SalesDetailDto {
    startDate?: string;
    endDate?: string;
    listLength?: number;
    refetchListLength?: number;
    unitNm: string;
    outputCd: string;       // 품번/출력코드
    supplyAmt: number;      // 할인액
    vatAmt: number;         // 부가세
}

/**
 * SAL2060_R01 검색 조건
 */
export interface SAL2060_R01Filter {
    dateRange: DateRange | undefined;  // 매출기간 (react-day-picker의 DateRange: { from: Date, to: Date })
    compCd: string;                    // 사업장 (all = 전체)
    customCd: string;                  // 거래처코드
    customNm: string;                  // 거래처명
    itemCd: string;                    // 품목코드 (백엔드와 통일)
    itemNm: string;                    // 품목명
}

/**
 * Default Filter
 */
export const defaultSAL2060_R01Filter: SAL2060_R01Filter = {
    dateRange: {
        from: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        to: new Date(),
    },
    compCd: "all",
    customCd: "",
    customNm: "",
    itemCd: "",
    itemNm: "",
};

/**
 * Default Header DTO
 */
export const defaultSAL2060_R01HeaderDto: SAL2060_R01HeaderDto = {
    ...defaultSalesHeaderDto,
    startDate: undefined,
    endDate: undefined,
    listLength: 0,
    refetchListLength: 0,
};

/**
 * Default Detail DTO
 */
export const defaultSAL2060_R01DetailDto: SAL2060_R01DetailDto = {
    ...defaultSalesDetailDto,
    startDate: undefined,
    endDate: undefined,
    listLength: 0,
    refetchListLength: 0,
    unitNm: "",
    outputCd: "",
    supplyAmt: 0,
    vatAmt: 0,
};
